import { jsx as _jsx } from "react/jsx-runtime";
import { getCNPJFormatado, getTelefoneFormatado } from '../../../utils';
import { getOrgaosEmpresas } from '../../../api';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 400 },
    {
        field: 'cnpj',
        headerName: 'CNPJ',
        width: 200,
        valueGetter: function (value) { return "".concat(getCNPJFormatado(value)); },
    },
    {
        field: 'telefone',
        headerName: 'Telefone',
        width: 200,
        valueGetter: function (value) { return "".concat(getTelefoneFormatado(value)); },
    },
    { field: 'email', headerName: 'Email', width: 300 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export default function OrgaosEmpresas() {
    return _jsx(GridBase, { pagina: PAGINAS.ORGAOS_EMPRESAS, paginaPermissao: FUNCIONALIDADES.ORGAOS_EMPRESAS, rota: ROUTES.ORGAOS_EMPRESAS, fetchData: function (str, _, pag) { return getOrgaosEmpresas(str, pag); }, columns: COLUNAS });
}
